import { LazyMotion, domAnimation, motion } from "framer-motion"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { animationBounceLeft } from "../../ds/animation.module.css"
import { btn, btnPrimary } from "../../ds/button.module.css"
import { WhiteArrowRight } from "../../ds/Shapes"
import { GreenCapsule, OrangeCapsule } from "../../ds/SvgIcons"
import G2Icon from "../../images/svgs/g2icon.svg"
import StarRating from "../../images/svgs/stars.svg"
import AnimatedText from "../../myne/AnimatedText/AnimatedText"
import { Button } from "../../myne/Button/Button"
import { PoweringBrands } from "../PoweringBrands"


const Hero = () => {
  const isUAEDomain = typeof window !== "undefined" && window.location.host.includes("ae")

  return (
    <>
      <LazyMotion features={domAnimation}>
        <div className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden bg-white px-4 pt-[150px] md:pt-[200px]">
          {/* Background blobs */}
          <motion.div
            className="absolute top-[10%] right-[-10%] w-[400px] h-[400px] rounded-full bg-gradient-to-br from-[#3BA1FF] to-[#62EB60] blur-3xl opacity-30 hidden md:block"
            animate={{
              x: ["0%", "-40%", "20%", "0%"],
              y: ["0%", "30%", "-20%", "0%"],
            }}
            transition={{
              duration: 25,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />

          <motion.div
            className="absolute bottom-[50%] md:bottom-[20%] left-[-20%] w-[250px] h-[250px] md:w-[500px] md:h-[500px] rounded-full bg-gradient-to-tr from-[#FFF06A] to-[#FF7AD2] blur-3xl opacity-40"
            animate={{
              x: ["0%", "40%", "-30%", "0%"],
              y: ["0%", "-20%", "40%", "0%"],
            }}
            transition={{
              duration: 30,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 3,
            }}
          />
          <div className="relative z-10 text-center md:max-w-4xl max-w-full">
            <h1 className="text-[40px] md:text-6xl lg:text-8xl font-semibold tracking-tight text-gray-900 !leading-[1.1]">
              <div>We Get Your</div>
              <div>
                <AnimatedText>Attendees</AnimatedText> Talking!
              </div>
            </h1>

            <p className="mt-4 text-base md:text-md lg:text-lg text-[#121212] max-w-3xl mx-auto leading-relaxed">
              Run pre-event, during-event & post-event social campaigns that get
              event attendees sharing, drive organic buzz, and bring in more
              registrations, without ad spend.
            </p>

            <div className="mt-6 flex items-center justify-center gap-4">
              <Button to="/request-a-demo/" variant="primary">
                Book a Demo
              </Button>
            </div>

            {/* powering brands */}
            <PoweringBrands />
          </div>
          <div className="md:px-10 md:mt-16 mt-12 w-full relative">
            <div className="hidden md:block">
              <StaticImage
                src="../../images/hero-banner.png"
                alt="Hero Banner"
                className="w-full rounded-3xl md:rounded-[40px] relative z-10"
                placeholder="blurred"
                loading="eager"
                layout="constrained"
                width={2400}
                quality={85}
                formats={["auto", "webp", "png"]}
              />
            </div>
            <div className="md:hidden">
              <StaticImage
                src="../../images/hero-banner-mobile.png"
                alt="Hero Banner"
                className="w-full rounded-3xl md:rounded-[40px] relative z-10"
                placeholder="blurred"
                loading="eager"
                layout="constrained"
                width={800}
                quality={85}
                formats={["auto", "webp", "png"]}
              />
            </div>
            {/* center circle ripple */}
            <div className="absolute top-[43%] md:top-[48%] left-[49%] -translate-x-1/2 -translate-y-1/2 z-4">
              <div className="relative w-[120px] h-[120px]">
                <div className="absolute inset-0 rounded-full border border-[#7251F4]/50 animate-rippleEngine"></div>
              </div>

              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="relative w-[100px] h-[100px]">
                  <div className="absolute inset-0 rounded-full border border-[#7251F4]/50 animate-rippleEngine delay-300"></div>
                </div>
              </div>

              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="relative w-[80px] h-[80px]">
                  <div className="absolute inset-0 rounded-full border border-[#7251F4]/50 animate-rippleEngine delay-500"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyMotion>
    </>
  )
}

export default Hero
